import * as d3 from 'd3';

export const setAlphaColor: (color: string, opacity: number) => string = (color, opacity) => {
  const rgbColor = d3.rgb(color);
  rgbColor.opacity = opacity;
  return `${rgbColor}`;
};
